import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './OnlyBuyerSellers.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function OnlyBuyerSellers(props) {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Only Buyers / Sellers";
    const [data, setData] = useState([]);
    let optionTypeComp = "Daily Market Tracker";
    // const [valuebt, setValueBt] = useState("BSell_Qty");
    const [valuebtn, setValueBtn] = useState("B");
    // const [valuebt, setValueBt] = useState("S");
    const [valueLi, setValueLi] = useState("10");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("B");
    // const [groupIndexNSE, setGroupIndexS] = useState("S");
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        if (groupValue === "NSE") {
            const getUrl = BaseURL + "OnlyBuyerSellers";
            // alert(`${getUrl}/${groupValue}/${valuebtn}/10`)
            fetch(`${getUrl}/${groupValue}/${valuebtn}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "OnlyBuyerSellers";
            // alert(`${getUrl}/${groupValue}/${valuebtn}/10`,"NSE")
            fetch(`${getUrl}/${groupValue}/${valuebtn}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getDataBSE")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroupNSE")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, valueLi]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Only Buyers Sellers",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Only Buyers / Sellers</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Only Buyers / Sellers</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='Buyer-sel-table-main'>
                                <div className='Buyer-sel-toggle'>
                                    <button id="btnGain" value="B" className={(valuebtn === "B") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Buyers</button>
                                    <button id="btnLoose" value="S" className={(valuebtn === "S") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Sellers</button>
                                </div>

                                <div className='Buyer-sel-right'>
                                    <div className='Buyer-sel-inner-select'>
                                        <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>

                                </div>
                                {/* <hr className="hrBuyerSeller"></hr> */}
                                <div className='Buyer-sel-table table-responsive'>
                                    <table className='table'>
                                        {(() => {
                                            if (valuebtn === "B") {
                                                return (
                                                    <><thead>
                                                        <tr>
                                                            <th className='text-left'>Company Name</th>
                                                            <th className="text-right">Bid Quantity(Nos.)</th>
                                                            <th className='text-right'>LTP(&#8377;)</th>
                                                            <th className='text-right'>Change(&#8377;)</th>
                                                            <th className='text-right'>Change(%)</th>

                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                            {currentTableData && currentTableData.map(
                                                                ({ lname, bbuy_qty, price, diff, change, co_code }) => (
                                                                    <tr>
                                                                        <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6> </td>


                                                                        <td className="text-right">{bbuy_qty}</td>

                                                                        <td className='text-right'>{(price != null) ? price.toFixed(2) : 0}</td>
                                                                        <td className='text-right'>{(diff != null) ? diff.toFixed(2) : 0}</td>
                                                                        <td className={(change > 0) ? 'textGreen text-right' : 'textRed text-right'}>{(change != null) ? change.toFixed(2) : 0}</td>

                                                                    </tr>
                                                                ))}
                                                        </tbody></>)
                                            } else {
                                                return (
                                                    <> <thead>
                                                        <tr>
                                                            <th className='text-left'>Company Name</th>

                                                            <th className="text-right">Sell Quantity(Nos.)</th>

                                                            <th className='text-right'>LTP(&#8377;)</th>
                                                            <th className='text-right'>Change(&#8377;)</th>
                                                            <th className='text-right'>Change(%)</th>

                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                            {currentTableData && currentTableData.map(
                                                                ({ lname, price, diff, change, BSell_Qty, co_code }) => (
                                                                    <tr>
                                                                        <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + co_code}>{lname}</h6></td>



                                                                        <td className="text-right">{BSell_Qty}</td>

                                                                        <td className='text-right'>{(price != null) ? price.toFixed(2) : 0}</td>
                                                                        {/* <td className='text-right'>{(diff != null) ? diff.toFixed(2) : 0}</td> */}
                                                                        <td className={(diff > 0) ? 'textGreen text-right' : 'textRed text-right'}>{(diff != null) ? diff.toFixed(2) : 0}</td>
                                                                        <td className={(change > 0) ? 'textGreen text-right' : 'textRed text-right'}>{(change != null) ? change.toFixed(2) : 0}</td>

                                                                    </tr>
                                                                ))}
                                                        </tbody> </>)
                                            }
                                        })()}
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default OnlyBuyerSellers;